
export default function FaultsListDirective(gettextCatalog, $filter, faultsService) {

    'ngInject';
    
    return {
        template: require('./list.html'),
        transclude: true,
        restrict: 'E',
        scope: { },
        controller: ListFaultConfigController,
        controllerAs: 'vm',
        bindToController: {
            faults: '='
        }
    };

    function ListFaultConfigController() {

        var vm = this;

        vm.configurations = [];
        vm.filteredConfigurations = [];
        vm.searchText = '';
        vm.errorFlag = false;
        vm.errorText = '';
        vm.loading = true;
        vm.onLoadErrorText = '';
        vm.onLoadErrorFlag = false;

        vm.pagination = {
            currentPage: 1,
            itemsPerPage: 15,
            maxSize: 1,
            startFrom: startFrom
        };

        //Sorting
        vm.predicate = 'name';
        vm.reverse = false;
        var orderBy = $filter('orderBy');

        vm.orderConfigurations = orderConfigurations;
        vm.applyFilter = applyFilter;
        vm.resetFlags = resetFlags;

        function init() {
            getFaultConfiguration();
        };

        init();

        function getFaultConfiguration() {
            vm.onLoadErrorText = null;
            vm.loading = true;

            return faultsService.getAllFaultConfigs()
                .then(function (configurations) {
                    vm.configurations = configurations.data;
                    applyFilter();
                })
                .catch(function (error) {
                    vm.onLoadErrorText = gettextCatalog.getString('An error occurred while retrieving configurations');
                })
                .finally(function () {
                    vm.loading = false;
                });
        }

        function orderConfigurations(predicate) {

            if (predicate === vm.predicate) {
                vm.reverse = !vm.reverse;
            }
            else {
                vm.reverse = true;
            }
            vm.predicate = predicate;
        }

        function applyFilter() {
            vm.filteredConfigurations = $filter('filter')(vm.configurations, vm.searchText);
        }

        //reset flags after user selects a new row
        function resetFlags() {
            vm.errorFlag = false;
            vm.errorText = '';
        }

        //Tracks the selected row.
        function setSelectedRow(configData) {
            vm.selectedRow = configData.name;
            resetFlags();
        }

        function startFrom() {
            return (vm.pagination.currentPage - 1) * vm.pagination.itemsPerPage;
        }
    }
}
